import { Product, Colour } from 'shared/types/product/index';
import { UIColorSwatchAndImagesWithSKU } from 'types/ui';

export const toColorSwatchesAndImages = (product: Product, showColorSwatch?: boolean) => {
  if (!product.colours) return [];

  const mappedColors: UIColorSwatchAndImagesWithSKU[] = [
    ...new Map(
      product.colours?.map((colour: Colour) => [
        colour.name,
        {
          swatch: {
            name: colour.description,
            description: colour.description,
            id: colour.code,
            sku: colour.sku,
            isDisabled: showColorSwatch ? !colour.inStock : undefined,
          },
          imageUrl: colour.images?.[0]?.src,
          hoverImageUrl: colour.images?.[1]?.src,
        },
      ]),
    ).values(),
  ];

  return mappedColors
    .map((swatch) => ({
      ...swatch,
      imageUrl: swatch.imageUrl as string,
    }))
    .sort((a, b) => {
      return Number(a.swatch.isDisabled) - Number(b.swatch.isDisabled);
    });
};
